import { connect } from "react-redux";

import {
    dropRedefinedModel,
    mergeRedefinedModel,
    redefineModel,
    removeModelFields,
    validateModalFormAction,
} from "../../../Engine/ActionCreators/ModalFormActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { PathResolver, withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withComponentHandleRegistry } from "../../../Engine/Core/ComponentHandleRegistry/WithComponentHandleRegistry";
import { withRedefinedViewModelIndex } from "../../RedefinedViewModelIndexContext";
import { AbsoluteModelPath, AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";

import { ModalForm } from "./ModalForm";
import { IModalFormsRegistry } from "./ModalFormsContext";

export interface ModalFormContainerProps {
    doNotValidateFormOnStart?: boolean;
    viewModelSelect: ViewModelSelect;
    verifiablePaths: AbsoluteModelPath[];
    resolvePath: PathResolver;
    onAfterOpen?: FormActionHandler;
    handleClose: () => void;
    modalRegistry: IModalFormsRegistry;
    modalId: string;
    bindingPath?: AbsoluteResolvedModelPath;
    removable: boolean;
}

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: ModalFormContainerProps) => ({
    redefineModel: () => dispatch(redefineModel),
    mergeRedefinedModel: () => dispatch(mergeRedefinedModel),
    dropRedefinedModel: () => dispatch(dropRedefinedModel),
    removeModelFields: () => {
        if (ownProps.removable && ownProps.bindingPath) {
            dispatch(removeModelFields(ownProps.bindingPath));
        }
    },
    onValidate: () =>
        dispatch(
            validateModalFormAction(
                ownProps.verifiablePaths,
                ownProps.viewModelSelect,
                ownProps.doNotValidateFormOnStart ?? false,
                ownProps.resolvePath
            )
        ),
});

export const ModalFormContainer = withResolvePaths(
    withViewModelSelect(
        connect(undefined, mapDispatchToProps)(withRedefinedViewModelIndex(withComponentHandleRegistry(ModalForm)))
    )
);
